module.exports = __webpack_public_path__ + "img/logo_principal_positivo.e03338db.png";